import React from 'react';
import { notification, Progress } from 'antd';

export const EXPORT_PROGRESS_NOTIFICATION_KEY = 'deepecho-export-progress';

export type ShowExportProgressOptions = {
  title: string;
  subtitle?: string;
  /** Omit or `null` for indeterminate (pulsing) bar. */
  percent?: number | null;
};

export function showExportProgressNotification(opts: ShowExportProgressOptions): void {
  const { title, subtitle, percent } = opts;
  const indeterminate = percent === undefined || percent === null;
  notification.open({
    key: EXPORT_PROGRESS_NOTIFICATION_KEY,
    message: title,
    description: (
      <div>
        <Progress
          percent={indeterminate ? undefined : Math.min(100, Math.max(0, percent))}
          status="active"
          size="small"
          showInfo={!indeterminate}
        />
        {subtitle ? (
          <div style={{ marginTop: 10, fontSize: 12, opacity: 0.88 }}>{subtitle}</div>
        ) : null}
      </div>
    ),
    duration: 0,
    placement: 'bottomRight',
    closable: false,
  });
}

export function closeExportProgressNotification(delayMs = 450): void {
  window.setTimeout(() => notification.destroy(EXPORT_PROGRESS_NOTIFICATION_KEY), delayMs);
}

export function dismissExportProgressNotification(): void {
  notification.destroy(EXPORT_PROGRESS_NOTIFICATION_KEY);
}

/** Indeterminate bar while `work` runs; brief 100% then auto-dismiss on success. */
export async function runWithIndeterminateExportNotification<T>(
  title: string,
  work: () => Promise<T>
): Promise<T> {
  showExportProgressNotification({ title, percent: null });
  try {
    const result = await work();
    showExportProgressNotification({ title, percent: 100 });
    closeExportProgressNotification();
    return result;
  } catch (e) {
    dismissExportProgressNotification();
    throw e;
  }
}
